module.exports = __webpack_public_path__ + "static/media/attribute.01900a14.md";